import { withDevtools } from '@angular-architects/ngrx-toolkit';
import { inject } from '@angular/core';
import { signalStore } from '@ngrx/signals';
import { AuthFacade } from 'mbs-ui-shared@facades/auth.facade';
import { AdministratorInCamelCase, PagedResponse, QueryFiltersParams, QueryPagingParams } from 'mbs-ui-shared@models';
import { AdministratorService } from 'mbs-ui-shared@services/administrator.service';
import { withPagingAndData } from 'mbs-ui-shared@store/withPagingAndDataStoreFeature/withPagingAndData';
import { Observable, switchMap, take } from 'rxjs';
import { map } from 'rxjs/operators';

export const AdministratorsStore = signalStore(
  { providedIn: 'root' },
  withDevtools('AdministratorsStore'),
  withPagingAndData<AdministratorInCamelCase>({
    selectId: (entity) => entity.id,
    getEntityById: () => {
      const service = inject(AdministratorService);
      const auth = inject(AuthFacade);
      return (id: string): Observable<AdministratorInCamelCase> =>
        auth.currentUser$.pipe(
          take(1),
          switchMap((user) => (user?.Id === id ? service.getMe() : service.getById(id)))
        );
    },
    getEntitiesByIds: () => {
      const service = inject(AdministratorService);
      return (ids: string[]): Observable<AdministratorInCamelCase[]> => service.get({ ids }).pipe(map((response) => response.data));
    },
    getEntities: () => {
      const service = inject(AdministratorService);
      return (params: QueryFiltersParams & QueryPagingParams): Observable<PagedResponse<AdministratorInCamelCase>> => service.get(params);
    }
  })
);

export type AdministratorsStore = InstanceType<typeof AdministratorsStore>;
